const SignFactor = () => {

    return(
        <div className="sign-container">
            <img src={require("../../../image/Paper-Upload.png")} />
            <p className="mt-3">صورتحساب خود را در این قسمت رها کنید.</p>
            <p className="mt-3" style={{color: "#B2B2B2"}}>انتخاب فایل</p>
        </div>
    )
}

export default SignFactor